import { compareMeasure } from '../components/Reports/EarlyCareerReport/elements/helpers'
import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces'
import { handleReportDisplayIdChange_ECR, authenticateUserOutsideLogin, thingsForSharedLink } from './UserActions';
import { authHeader } from '../javascript/auth-header';

export function loadEarlyCareerSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;

        var headers = authHeader();
        fetch(url, {
            method: 'GET',
            headers: headers
        })
        .then(function (response) {
            return response.json();
        })
        .then(async function (json) {
            var done = await authenticateUserOutsideLogin();
            dispatch(thingsForSharedLink());

            var link: LinkStuff = json;
            if (link.link_id == -1) {
                dispatch({
                    type: "BAD_LINK",
                    payload: json
                });
                dispatch(push('/reports/bad_link'));
            } else {
                dispatch(handleReportDisplayIdChange_ECR({ value: link.display_id }));
                    
                const filterSavedValues = {
                    ecr_award: link.ecr_award == 'null' ? [] : link.ecr_award.split(','),
                    gender: link.gender == 'null' ? [] : link.gender.split(','),
                    suborg: link.suborg == 'null' ? [] : link.suborg.split(','),
                    funder: link.funder == 'null' ? [] : link.funder.split(','),
                    no_compare: (link.no_compare === 'true'),
                    ecr_award_compare: (link.ecr_award_compare === 'true'),
                    gender_compare: (link.gender_compare === 'true')
                };

                const selections = {
                    checked_1: filterSavedValues.ecr_award.map(x => x == '1').length >= 1,
                    checked_0: filterSavedValues.ecr_award.filter(x => x == '0').length >= 1,
                    checked_M: filterSavedValues.gender.filter(x => x == 'M').length >= 1,
                    checked_F: filterSavedValues.gender.filter(x => x == 'F').length >= 1,
                    checked_U: filterSavedValues.gender.filter(x => x == 'U').length >= 1,
                    checked_suborg1: filterSavedValues.suborg.filter(x => x == 'suborg1').length >= 1,
                    checked_suborg2: filterSavedValues.suborg.filter(x => x == 'suborg2').length >= 1,
                    checked_suborg3: filterSavedValues.suborg.filter(x => x == 'suborg3').length >= 1,
                    checked_suborg4: filterSavedValues.suborg.filter(x => x == 'suborg4').length >= 1,
                    checked_suborg5: filterSavedValues.suborg.filter(x => x == 'suborg5').length >= 1,
                    checked_NIH: filterSavedValues.funder.filter(x => x == 'NIH').length >= 1,
                    checked_NSF: filterSavedValues.funder.filter(x => x == 'NSF').length >= 1,
                    checked_nonfed: filterSavedValues.funder.filter(x => x == 'nonfed').length >= 1,
                    checked_otherfunder: filterSavedValues.funder.filter(x => x == 'other').length >= 1,

                    checked_no_compare: filterSavedValues.no_compare,
                    checked_ecr_award_compare: filterSavedValues.ecr_award_compare,
                    checked_gender_compare: filterSavedValues.gender_compare
                }

                dispatch(loadEarlyCareerReportCounts(
                    link.display_id,
                    filterSavedValues,
                    link.vintage));

                dispatch(loadEarlyCareerReport(
                    link.display_id,
                    link.university,
                    filterSavedValues,
                    selections,
                    link.vintage));
            }
        });
    };
}

export function loadReleaseDate(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/get_ecr_release_date/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "ECR_RELEASE",
                    payload: json['release_date']
                })
            });
    };
}

export function loadEarlyCareerReport(
    display_id,
    university,
    SavedFilterValues,
    Selections,
    vintage
) {

    return dispatch => {
        dispatch({
            type: "EARLYCAREER_REPORT_LOADING",
            payload: {
                EarlyCareerReportFilterSavedValues: SavedFilterValues,
                EarlyCareerReportFilterSelection: Selections
            }
        })
        dispatch(loadEarlyCareerReportBasicInfo(display_id, university, vintage));
        dispatch(loadSuborgs(display_id, vintage));
        dispatch(FilterEarlyCareerReport(display_id, SavedFilterValues, vintage));
        dispatch(loadReleaseDate(display_id, vintage));
    }
}

export function loadEarlyCareerReportCounts(
    display_id,
    SavedFilterValues,
    vintage
) {
    return (dispatch) => {
        //console.log('lets load some counts');
        let flattenedValues = { selected_ecr_award: 'null', selected_gender: 'null', selected_suborg: 'null', selected_funder: 'null' };
        if (SavedFilterValues != undefined) {
            let selected_suborg = (SavedFilterValues.suborg == undefined) ? 'null' : SavedFilterValues.suborg.join(',') == '' ? 'null' : SavedFilterValues.suborg.join(',');
            selected_suborg = selected_suborg.replaceAll('suborg', '');

            flattenedValues = {
                selected_ecr_award: (SavedFilterValues.ecr_award == undefined) ? 'null' : SavedFilterValues.ecr_award.join(',') == '' ? 'null' : SavedFilterValues.ecr_award.join(','),
                selected_gender: (SavedFilterValues.gender == undefined) ? 'null' : SavedFilterValues.gender.join(',') == '' ? 'null' : SavedFilterValues.gender.join(','),
                selected_suborg: selected_suborg,
                selected_funder: (SavedFilterValues.funder == undefined) ? 'null' : SavedFilterValues.funder.join(',') == '' ? 'null' : SavedFilterValues.funder.join(',')
            }
        }

        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/filter_counts/'
            + display_id + '/'
            + flattenedValues.selected_ecr_award + '/'
            + flattenedValues.selected_gender + '/'
            + flattenedValues.selected_suborg + '/'
            + flattenedValues.selected_funder + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                
                dispatch({
                    type: "FILTER_COUNTS",
                    payload: json
                })
            });
    };
}

export function clearAllData(
    FilterEarlyCareerReport,
    display_id,
    savedValues,
    vintage
) {
    return dispatch => {
        const compare_measure = compareMeasure(savedValues);
        
        dispatch({ type: "JOURNAL_RANK", payload: null })
        dispatch({ type: "AWARD_COUNT", payload: null })
        dispatch({ type: "AUTHOR", payload: null })
        dispatch({ type: "PUB", payload: null })
        dispatch({ type: "POE", payload: null })
        dispatch({ type: "GRANT", payload: null })
        dispatch({ type: "TEAM", payload: null })

        if (compare_measure == 1 || compare_measure == 2) {
            dispatch({ type: "JOURNAL_RANK_2", payload: null })
            dispatch({ type: "AWARD_COUNT_2", payload: null })
            dispatch({ type: "AUTHOR_2", payload: null })
            dispatch({ type: "PUB_2", payload: null })
            dispatch({ type: "POE_2", payload: null })
            dispatch({ type: "GRANT_2", payload: null })
            dispatch({ type: "TEAM_2", payload: null })
        }

        FilterEarlyCareerReport(display_id, savedValues, vintage);
    }
}

export function FilterEarlyCareerReport(
    display_id,
    savedValues,    
    vintage
) {
    return dispatch => {
        const compare_measure = compareMeasure(savedValues);
        let selected_ecr_award = (savedValues.ecr_award == undefined) ? 'null' : savedValues.ecr_award.join(',') == '' ? 'null' : savedValues.ecr_award.join(',');
        let selected_gender = (savedValues.gender == undefined) ? 'null' : savedValues.gender.join(',') == '' ? 'null' : savedValues.gender.join(',');
        let selected_suborg = (savedValues.suborg == undefined) ? 'null' : savedValues.suborg.join(',') == '' ? 'null' : savedValues.suborg.join(',');
        selected_suborg = selected_suborg.replaceAll('suborg', '');
        const selected_funder = (savedValues.funder == undefined) ? 'null' : savedValues.funder.join(',') == '' ? 'null' : savedValues.funder.join(',');

        dispatch(loadEarlyCareerReportSankey(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, vintage));

        //for comparing by ecr award or gender, run sp twice with each possible value (ecr_award 1,0 and gender F,M).
        if (compare_measure != 0) { 
            if (compare_measure == 1) {
                selected_ecr_award = '1';
            }
            else if (compare_measure == 2) {
            selected_gender = 'F';
            }
        }
        //console.log(compare_measure);
        //console.log(selected_suborg);
        dispatch(loadEarlyCareerReportJournalRank(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "JOURNAL_RANK", vintage, compare_measure));
        dispatch(loadEarlyCareerReportAwardCounts(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "AWARD_COUNT", vintage, compare_measure));
        dispatch(loadEarlyCareerReportAuthor(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "AUTHOR", vintage, compare_measure));
        dispatch(loadEarlyCareerReportPub(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "PUB", vintage, compare_measure));
        dispatch(loadEarlyCareerReportPOE(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "POE", vintage, compare_measure));
        dispatch(loadEarlyCareerReportGrantDollars(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "GRANT", vintage, compare_measure));
        dispatch(loadEarlyCareerReportTeam(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "TEAM", vintage, compare_measure));

        if (compare_measure == 1 || compare_measure == 2) {
            if (compare_measure == 1)
                selected_ecr_award = '0';
            else if (compare_measure == 2) {
                selected_gender = 'M';
            }

            dispatch(loadEarlyCareerReportJournalRank(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "JOURNAL_RANK_2", vintage, compare_measure));
            dispatch(loadEarlyCareerReportAwardCounts(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "AWARD_COUNT_2", vintage, compare_measure));
            dispatch(loadEarlyCareerReportAuthor(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "AUTHOR_2", vintage, compare_measure));
            dispatch(loadEarlyCareerReportPub(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "PUB_2", vintage, compare_measure));
            dispatch(loadEarlyCareerReportPOE(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "POE_2", vintage, compare_measure));
            dispatch(loadEarlyCareerReportGrantDollars(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "GRANT_2", vintage, compare_measure));
            dispatch(loadEarlyCareerReportTeam(display_id, selected_ecr_award, selected_gender, selected_suborg, selected_funder, "TEAM_2", vintage, compare_measure));
        }
    }
}

export function loadEarlyCareerReportBasicInfo(
    display_id,
    university,
    vintage
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/basic_info/'
            + display_id + '/'
            + vintage;

        
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                json["university"] = university;
                dispatch({
                    type: "BASIC_INFO",
                    payload: json
                })
            });
    };
}

export function loadSuborgs(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/top_modal_suborgs/'
            + display_id + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            //filtered by display_id and ordered by rank
            .then(function (json) {
                const suborgsDefined = (json !== undefined && json.length === 5)
                
                dispatch({
                    type: "SUBORGS_DEFINED",
                    payload: suborgsDefined
                })

                dispatch({
                    type: "SUBORGS",
                    payload: json
                })
            });
    };
}

export function loadEarlyCareerReportAwardCounts(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/award_count/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}

export function loadEarlyCareerReportJournalRank(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/journal_rank/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}


export function loadEarlyCareerReportAuthor(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/author_class/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}


export function loadEarlyCareerReportPub(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/pub_count/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}

export function loadEarlyCareerReportSankey(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    vintage
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/sankey/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: "SANKEY",
                    payload: json
                })
            });
    };
}

export function loadEarlyCareerReportPOE(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/poe/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}

export function loadEarlyCareerReportGrantDollars(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/grant_count/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}

export function loadEarlyCareerReportTeam(
    display_id,
    selected_ecr_award,
    selected_gender,
    selected_suborg,
    selected_funder,
    type,
    vintage,
    compare_measure
) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/team/'
            + display_id + '/'
            + selected_ecr_award + '/'
            + selected_gender + '/'
            + selected_suborg + '/'
            + selected_funder + '/'
            + compare_measure + '/'
            + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })

            //filtered by display_id and ordered by rank
            .then(function (json) {
                dispatch({
                    type: type,
                    payload: json
                })
            });
    };
}

export function clearFilterSelection(values) {
    return dispatch => {
        dispatch({
            type: "FILTER_CLEAR",
            payload: values
        });
    };
}

export function setFilterValues(key, value) {
    return dispatch => {
        dispatch({
            type: "FILTER_SAVED_VALUES",
            payload: { key: key, value: value }
        });
    };
}


export function handleFilterSelection(key, value) {
    return dispatch => {
        dispatch({
            type: "FILTER_SELECTION",
            payload: { key: key, value: value }
        });
    };
}


export function loadEarlyCareerMethodology(display_id, vintage) {
    return dispatch => {
        const url = `/IRISReportsMicroservice/api/EarlyCareerReport/methodology/${display_id}/${vintage}`;
        const headers = authHeader();
        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(data => {
                dispatch({
                    type: 'EMPLOYEE_METHODOLOGY',
                    payload: data[0]
                })

                dispatch(loadEarlyCareerProfileInfo(display_id, vintage, data[0].start_year, data[0].end_year));

            })
    }
}

export function loadEarlyCareerProfileInfo(display_id, vintage, start_year, end_year) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/EarlyCareerReport/profile_info/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                //copy-paste code from new employee report
                //dispatch(loadEarlyCareerLocation(display_id, vintage, json[0].state_fips, json[0].university, json[0].state, start_year, end_year, json[0].employees));

                dispatch({
                    type: "EMPLOYEE_PROFILE_INFO",
                    payload: json[0]
                })
            });
    };
}






